import { useEffect} from 'react';
import { BrowserRouter as Router, Routes as Switch, Route, Navigate } from 'react-router-dom';
import "./styles.css";
import "./stylesSim.css";
import {Login} from './components/pages/Login';
import {Start} from './components/pages/Start';
import {LoginVerify} from './components/pages/LoginVerify';
import {AgentTestSession} from './components/pages/AgentTestSession';
import {VerifyEmail} from './components/pages/VerifyEmail';
import {VerifyPhone} from './components/pages/VerifyPhone';
import {ResetPassword} from './components/pages/ResetPassword';
import {RestoreUsername} from './components/pages/RestoreUsername';
import {CreatePassword} from './components/pages/CreatePassword';
import {PasswordReset} from './components/pages/PasswordReset';
import {AccountExists} from './components/pages/AccountExists';
import {VerificationPhoneCodeType} from './components/pages/VerificationPhoneCodeType';
import {SuccessfullyLoggedIn} from './components/pages/SuccessfullyLoggedIn';
import {Register} from './components/pages/Register';
import {CreateCredentails} from './components/pages/CreateCredentials';
import {TwoStepVerification} from './components/pages/TwoStepVerification';
import {VerifyContact} from './components/pages/VerifyContact';
import {AuthMethodSelection} from './components/pages/AuthMethodSelection';
import {Congratulations} from './components/pages/Congratulations';
import RedirectByReseller from './components/routes/RedirectByReseller';
import RequireReseller from './components/routes/RequireReseller';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import {Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button} from '@mui/material';
import { hideErrorDialog } from "./features/errorDialog";
import { fetchReseller } from "./features/reseller";
import { ComingSoon } from './components/pages/ComingSoon';
import AllowFeatureByReseller from './components/routes/AllowFeatureByReseller';
import { applyTheme, applyDocumentAssets } from './portalSettings';
import StepUpDialog from './components/widgets/StepUpDialog';

function App() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const errorDialog = useSelector((state) => state.errorDialog.value);
  const { value: resellerData, status } = useSelector((state) => state.reseller);

  useEffect(() => {
    if (!resellerData && status === "idle") {
      dispatch(fetchReseller());
    }
  }, [dispatch, resellerData, status]);

  /**
   * העיצוב והנכסים של הריסיילר.
   *
   * שני הקריאות בתלות אחת, ולא בשתיים: שתיהן נגזרות מאותה תשובה, וההפרדה שלהן הייתה
   * מזמינה מצב שבו הצבעים של ריסיילר אחד מצוירים מעל הלוגו של השני.
   *
   * `applyTheme` נקרא גם כשאין `theme`: הוא מסמן את הערכה על `<html>`, וזה מה שמאפשר
   * ל-CSS להבדיל בין הערכות. `resellerData` שהוא `null` עדיין מקבל את ערכת ברירת
   * המחדל, כלומר בדיוק המסך שהיה.
   */
  useEffect(() => {
    applyTheme(resellerData);
    if (resellerData) applyDocumentAssets(resellerData);
  }, [resellerData]);

  const handleErrorDialogClose = () => {
    dispatch(hideErrorDialog());
  };

  return (
    <>
      <StepUpDialog />
      <Router>
        <Switch>
            {/*
                **עץ ניתוב אחד, לשתי ערכות העיצוב.**

                עד כה הוא היה מפוצל לשניים: שכבת `RedirectByReseller` שכל מסכי הזרימה
                ישבו תחתיה, ומתחתיה כל ריסיילר סלולרי הופנה חזרה למסך ההתחברות שלו.
                המשמעות הייתה ששרשרת ההרשמה כולה לא הייתה נגישה לו - לא כי לא נבנתה,
                אלא כי הניתוב בלע אותה - וש-`/login-sim-customers` היה חייב להתקיים
                ככתובת נפרדת כדי לצאת מהשכבה הזו.

                עכשיו יש מסלול אחד לכל מסך, וערכת העיצוב אינה שאלה של ניתוב: היא
                נכתבת על `<html>` ע"י `applyTheme`, וכל מסך מצויר בה. מסך ההתחברות
                עצמו בוחר בין שתי פריסות באותה הכרעה בדיוק (ראה `Login`).
            */}
            <Route path='/' element={<RequireReseller />}>
              {/* מסך הפתיחה "הרשמה או התחברות". הוא היחיד שערכת העיצוב מייתרת -
                  לריסיילר סלולרי מסך ההתחברות הוא נקודת הכניסה, וההרשמה מוצעת מתוכו. */}
              <Route path='/' element={<RedirectByReseller><Start /></RedirectByReseller>} />
              <Route path='/start' element={<RedirectByReseller><Start /></RedirectByReseller>} />

              <Route path='/login' element={<Login />} />
              {/* הכתובת שהייתה למסך ההתחברות הסלולרי. היא נשארת כהפניה, ולא נמחקת:
                  היא יושבת במועדפים, בהיסטוריית הדפדפן ובקישורים שכבר נשלחו. */}
              <Route path='/login-sim-customers' element={<Navigate to='/login' replace />} />

              {/* ההרשמה. `AllowFeatureByReseller` על המסך הראשון בלבד - הוא מסך
                  הפעולה, ושאר השרשרת היא המשך של הרשמה שכבר התחילה. השערים האמיתיים
                  הם בשרת, וזה רק מונע זרימה שנפתחת ונחסמת בסופה. */}
              <Route path='/register' element={<AllowFeatureByReseller feature='allowRegistration'><Register /></AllowFeatureByReseller>} />
              <Route path='/verify-email' element={<VerifyEmail />} />
              <Route path='/verify-phone' element={<VerifyPhone />} />
              <Route path='/verification-phone-code-type' element={<VerificationPhoneCodeType />} />
              <Route path='/create-credentials' element={<CreateCredentails />} />
              {/* "כבר יש לכם חשבון" - סיום ההרשמה כשהיא נעצרה בגלל חשבון קיים. בלי
                  `AllowFeatureByReseller`: הוא אינו מסך של פעולה אלא של תשובה,
                  ולסגור אותו לפי מתג היה מחזיר את הנרשם למסך שאין בו הסבר. */}
              <Route path='/account-exists' element={<AccountExists />} />
              <Route path='/congratulations' element={<Congratulations />} />

              {/* ההמשך של ההתחברות - אימות דו-שלבי, בחירת שיטה ורישום שיטה. */}
              <Route path='/login-verify' element={<LoginVerify />} />
              {/* החזרת מצב "ממתין לאימות" לצורך בדיקה, מלוח ניהול ה-SSO. ראה את
                  הדוקבלוק בקומפוננטה - הטוקן שנכנס כאן אינו פותח דבר. */}
              <Route path='/agent-test-session' element={<AgentTestSession />} />
              <Route path='/auth-method-selection' element={<AuthMethodSelection />} />
              <Route path='/two-step-verification' element={<TwoStepVerification />} />
              <Route path='/verify-contact' element={<VerifyContact />} />
              <Route path='/successfully-logged-in' element={<SuccessfullyLoggedIn />} />

              {/* שחזור שם משתמש וסיסמה. `/create-password` אינו מגודר במכוון: הוא
                  הפדיון של קישור שכבר נשלח, ולא הצעה של פעולה - ראה
                  `AllowFeatureByReseller`. */}
              <Route path='/restore-username' element={<AllowFeatureByReseller feature='allowUsernameRecovery'><RestoreUsername /></AllowFeatureByReseller>} />
              <Route path='/reset-password' element={<AllowFeatureByReseller feature='allowPasswordReset'><ResetPassword /></AllowFeatureByReseller>} />
              <Route path='/password-reset' element={<PasswordReset />} />
              <Route path='/create-password' element={<CreatePassword />} />

              <Route path='/coming-soon' element={<ComingSoon />} />
            </Route>
        </Switch>
      </Router>
      <Dialog open={errorDialog.isOpen} onClose={handleErrorDialogClose}>
        <DialogTitle>{t(errorDialog.title)}</DialogTitle>
        <DialogContent>
        <Typography component="div">{t(errorDialog.text)}</Typography>
        </DialogContent>
        <DialogActions> 
          <Button  variant="contained"onClick={handleErrorDialogClose} size="large">{t('Close')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default App;
